export default __webpack_public_path__ + "static/media/ios-box.bbb2fe35.svg";